<template>
  <header class="navbar navbar-expand-lg navbar-light bg-white sticky-top shadow-sm">
    <div class="container">
      <router-link to="/" class="navbar-brand">
        <img src="https://assets.thesupersoft.com/englishmate/em-logo.png" alt="EnglishMate" height="40">
      </router-link>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <router-link to="/" class="nav-link">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/learn-english/vocabulary-playground" class="nav-link">Vocabulary Playground</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/about" class="nav-link">About Us</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/contact" class="nav-link">Contact</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/conversation" class="nav-link btn btn-primary text-white px-3 rounded-pill">Practice</router-link>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>

<style scoped>
.navbar {
  height: 80px;
  z-index: 1030;
}

.nav-link {
  font-weight: 500;
  color: #333 !important;
  padding: 0.5rem 1rem !important;
  transition: color 0.2s;
}

.nav-link:hover {
  color: #2f66a9 !important;
}

.nav-link.btn-primary {
  color: white !important;
  background-color: #2f66a9;
  border-color: #2f66a9;
}

.nav-link.btn-primary:hover {
  background-color: #245089;
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(47,102,169,0.2);
}

@media (max-width: 992px) {
  .navbar {
    height: auto;
    padding: 0.5rem 1rem;
  }
  
  .nav-link.btn-primary {
    margin-top: 0.5rem;
    display: inline-block;
  }
}
</style> 